'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _dec2, _class, _class2, _temp; /**
                                          * Created by zfc on 2017/7/20.
                                          */

// GoeasyCarousel


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

var _reactRedux = require('react-redux');

var _reactRouterRedux = require('react-router-redux');

var _mainSearchPage = require('redux/modules/mainSearchPage');

var mainSearchPageAction = _interopRequireWildcard(_mainSearchPage);

var _background = require('redux/modules/background');

var _reduxAsyncConnect = require('redux-async-connect');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MainSeachPage = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var dispatch = _ref.store.dispatch;
    var location = _ref.location;

    var promises = [];
    var query = location.query;
    var filter = '';
    var page = null;
    var orderItem = '';
    var direction = '';
    var searchType = '';
    if (query.findValue) {
      filter = (0, _extends3.default)({}, filter, { FindValue: query.findValue });
    }
    if (query.isExperienceProduct) {
      filter = (0, _extends3.default)({}, filter, { isExperienceProduct: query.isExperienceProduct });
    }
    if (query.isExperienceGoods) {
      filter = (0, _extends3.default)({}, filter, { isExperienceGoods: query.isExperienceGoods });
    }
    if (query.isAppreciationGoods) {
      filter = (0, _extends3.default)({}, filter, { isAppreciationGoods: query.isAppreciationGoods });
    }
    if (query.shopType) {
      filter = (0, _extends3.default)({}, filter, { shopType: query.shopType });
    }
    if (query.honorId) {
      filter = (0, _extends3.default)({}, filter, { honorId: query.honorId });
    }
    if (query.page) {
      page = query.page;
    }
    if (query.orderItem) {
      orderItem = query.orderItem;
    }
    if (query.direction) {
      direction = query.direction;
    }
    if (query.searchType) {
      searchType = query.searchType;
    }
    promises.push(dispatch((0, _background.changeHeaderText)('艺品网搜索')));
    promises.push(dispatch(mainSearchPageAction.load(filter, {
      orderItem: orderItem,
      direction: direction
    }, page, searchType)));
    return _promise2.default.all(promises);
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    data: state.mainSearchPage.data,
    changeSearchType: state.mainSearchPage.changeSearchType
  };
}, (0, _extends3.default)({}, mainSearchPageAction, {
  routerPush: _reactRouterRedux.push,
  routerReplace: _reactRouterRedux.replace
})), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(MainSeachPage, _Component);

  function MainSeachPage() {
    (0, _classCallCheck3.default)(this, MainSeachPage);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(MainSeachPage).call(this));

    _this.state = {
      filter: ''
    };
    return _this;
  }

  (0, _createClass3.default)(MainSeachPage, [{
    key: 'onSearchChange',
    value: function onSearchChange(value) {
      var _props = this.props;
      var routerPush = _props.routerPush;
      var location = _props.location;
      var changeSearchTypeToFalse = _props.changeSearchTypeToFalse;

      if (routerPush) {
        var query = {};
        if (location.query.findValue) {
          query.findValue = location.query.findValue;
        }
        changeSearchTypeToFalse();
        routerPush({ pathname: location.pathname, query: (0, _extends3.default)({}, query, { searchType: value }) });
      }
    }
  }, {
    key: 'onOrderItemClick',
    value: function onOrderItemClick(val) {
      var _props2 = this.props;
      var routerPush = _props2.routerPush;
      var location = _props2.location;

      switch (val) {
        //  ---poduct----
        case 'isExperienceProduct':
          if (routerPush) {
            if (!location.query.isExperienceProduct || location.query.isExperienceProduct === '0') {
              var currentQuery = (0, _extends3.default)({}, location.query, { isExperienceProduct: '1' });
              if (currentQuery.isExperienceGoods) {
                delete currentQuery.isExperienceGoods;
              }
              if (currentQuery.isAppreciationGoods) {
                delete currentQuery.isAppreciationGoods;
              }
              if (currentQuery.page) {
                delete currentQuery.page;
              }
              routerPush({ pathname: location.pathname, query: (0, _extends3.default)({}, currentQuery) });
            }
          }
          break;
        case 'isExperienceGoods':
          if (routerPush) {
            if (!location.query.isExperienceGoods || location.query.isExperienceGoods === '0') {
              var _currentQuery = (0, _extends3.default)({}, location.query, { isExperienceGoods: '1' });
              if (_currentQuery.isExperienceProduct) {
                delete _currentQuery.isExperienceProduct;
              }
              if (_currentQuery.isAppreciationGoods) {
                delete _currentQuery.isAppreciationGoods;
              }
              if (_currentQuery.page) {
                delete _currentQuery.page;
              }
              routerPush({ pathname: location.pathname, query: (0, _extends3.default)({}, _currentQuery) });
            }
          }
          break;
        case 'isAppreciationGoods':
          if (routerPush) {
            if (!location.query.isAppreciationGoods || location.query.isAppreciationGoods === '0') {
              var _currentQuery2 = (0, _extends3.default)({}, location.query, { isAppreciationGoods: '1' });
              if (_currentQuery2.isExperienceProduct) {
                delete _currentQuery2.isExperienceProduct;
              }
              if (_currentQuery2.isExperienceGoods) {
                delete _currentQuery2.isExperienceGoods;
              }
              if (_currentQuery2.page) {
                delete _currentQuery2.page;
              }
              routerPush({ pathname: location.pathname, query: (0, _extends3.default)({}, _currentQuery2) });
            }
          }
          break;
        case 'price':
          if (routerPush) {
            var direction = location.query.direction === 'ASC' ? 'DESC' : 'ASC';
            routerPush({ pathname: location.pathname, query: (0, _extends3.default)({}, location.query, { orderItem: val, direction: direction }) });
          }
          break;
        case 'addTime':
          if (routerPush) {
            if (!(location.query.orderItem === 'addTime' && location.query.direction === 'DESC')) {
              var _direction = 'DESC';
              routerPush({ pathname: location.pathname, query: (0, _extends3.default)({}, location.query, { orderItem: val, direction: _direction }) });
            }
          }
          break;
        // --shop---
        case 'mortarStores':
          if (routerPush) {
            if (!location.query.shopType || location.query.shopType === 'M0044350000000000000000002') {
              routerPush({
                pathname: location.pathname,
                query: (0, _extends3.default)({}, location.query, { shopType: 'M0044350000000000000000001' })
              });
            }
          }
          break;
        case 'masterShop':
          if (routerPush) {
            if (!location.query.shopType || location.query.shopType === 'M0044350000000000000000001') {
              routerPush({
                pathname: location.pathname,
                query: (0, _extends3.default)({}, location.query, { shopType: 'M0044350000000000000000002' })
              });
            }
          }
          break;
        // ---designer---
        case 'YataiMaster':
          if (routerPush) {
            if (location.query.honorId !== 'M0043120000000000000000001') {
              routerPush({
                pathname: location.pathname,
                query: (0, _extends3.default)({}, location.query, { honorId: 'M0043120000000000000000001' })
              });
            }
          }
          break;
        case 'GuoMaster':
          if (routerPush) {
            if (location.query.honorId !== 'M0043120000000000000000002') {
              routerPush({
                pathname: location.pathname,
                query: (0, _extends3.default)({}, location.query, { honorId: 'M0043120000000000000000002' })
              });
            }
          }
          break;
        case 'HangYeMaster':
          if (routerPush) {
            if (location.query.honorId !== 'M0043120000000000000000004') {
              routerPush({
                pathname: location.pathname,
                query: (0, _extends3.default)({}, location.query, { honorId: 'M0043120000000000000000004' })
              });
            }
          }
          break;
        case 'ShengMaster':
          if (routerPush) {
            if (location.query.honorId !== 'M0043120000000000000000003') {
              routerPush({
                pathname: location.pathname,
                query: (0, _extends3.default)({}, location.query, { honorId: 'M0043120000000000000000003' })
              });
            }
          }
          break;
        case 'ShiMaster':
          if (routerPush) {
            if (location.query.honorId !== 'M0043129999999999999999999') {
              routerPush({
                pathname: location.pathname,
                query: (0, _extends3.default)({}, location.query, { honorId: 'M0043129999999999999999999' })
              });
            }
          }
          break;
        case 'zw':
          break;
        default:
          if (routerPush) {
            var query = {};
            if (location.query.searchType) {
              query.searchType = location.query.searchType;
            }
            if (location.query.findValue) {
              query.findValue = location.query.findValue;
            }
            routerPush({ pathname: location.pathname, query: (0, _extends3.default)({}, query) });
          }
      }
    }
  }, {
    key: 'onPageItemClick',
    value: function onPageItemClick(page) {
      var _props3 = this.props;
      var routerPush = _props3.routerPush;
      var location = _props3.location;

      if (routerPush) {
        routerPush({ pathname: location.pathname, query: (0, _extends3.default)({}, location.query, { page: page }) });
        this.scrollToAnchor('homePageOrderBar');
      }
    }
  }, {
    key: 'onSearch',
    value: function onSearch(val) {
      var _props4 = this.props;
      var routerPush = _props4.routerPush;
      var location = _props4.location;

      if (routerPush) {
        if (val) {
          var query = {};
          if (location.query.searchType) {
            query.searchType = location.query.searchType;
          } else {
            query.searchType = 'product';
          }
          query.findValue = val;
          // changeSearchTypeToTrue();
          routerPush({ pathname: location.pathname, query: query });
        }
      }
    }
  }, {
    key: 'scrollToAnchor',
    value: function scrollToAnchor(anchorName) {
      if (anchorName) {
        var anchorElement = document.getElementById(anchorName);
        if (anchorElement) {
          anchorElement.scrollIntoView();
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props5 = this.props;
      var data = _props5.data;
      var location = _props5.location;
      var changeSearchType = _props5.changeSearchType;
      var changeSearchTypeToTrue = _props5.changeSearchTypeToTrue;

      var currentPage = 0;
      var productDiv = _react2.default.createElement('div', null);
      var totalPageNumber = 1;
      var searchType = location.query.searchType;
      // 分析瀑布列表显示内容
      if (data) {
        if (searchType) {
          switch (searchType) {
            case 'product':
              var mainSearchProductList = data.mainSearchProductList;
              var mainSearchProductListError = data.mainSearchProductListError;
              var mainSearchProductListRecordCount = data.mainSearchProductListRecordCount;
              var mainSearchProductListPagesize = data.mainSearchProductListPagesize;

              if (mainSearchProductListError) {
                productDiv = _react2.default.createElement(
                  'li',
                  { style: { width: '100%', fontSize: 16, textAlign: 'center' } },
                  mainSearchProductListError
                );
              } else {
                if (location.query && !isNaN(parseInt(location.query.page, 10))) {
                  currentPage = parseInt(location.query.page, 10);
                }
                productDiv = _react2.default.createElement(
                  'ul',
                  { style: { width: '100%' } },
                  mainSearchProductList instanceof Array ? mainSearchProductList.map(function (item, index) {
                    var result = '';
                    if (item.productCharacter === 'M0043080000000000000000001') {
                      result = _react2.default.createElement(_components.ProductInfo, { key: item.id, index: index, product: item });
                    } else if (item.productCharacter === 'M0043080000000000000000002') {
                      result = _react2.default.createElement(_components.ProductInfo, { key: item.id, isCustom: true, index: index, product: item });
                    }
                    return result;
                  }) : _react2.default.createElement(
                    'li',
                    { style: { width: '100%', fontSize: 16, textAlign: 'center' } },
                    '未搜索到相关信息'
                  )
                );
              }
              totalPageNumber = parseInt(mainSearchProductListRecordCount / mainSearchProductListPagesize, 10);
              if (mainSearchProductListRecordCount % mainSearchProductListPagesize > 0) {
                ++totalPageNumber;
              }
              break;
            case 'shop':
              var mainSearchShopList = data.mainSearchShopList;
              var mainSearchShopListError = data.mainSearchShopListError;
              var mainSearchShopListRecordCount = data.mainSearchShopListRecordCount;
              var mainSearchShopListPagesize = data.mainSearchShopListPagesize;

              if (mainSearchShopListError) {
                productDiv = _react2.default.createElement(
                  'li',
                  { style: { width: '100%', fontSize: 16, textAlign: 'center' } },
                  mainSearchShopListError
                );
              } else {
                if (location.query && !isNaN(parseInt(location.query.page, 10))) {
                  currentPage = parseInt(location.query.page, 10);
                }
                productDiv = _react2.default.createElement(
                  'ul',
                  { style: { width: '100%' } },
                  mainSearchShopList instanceof Array ? mainSearchShopList.map(function (item, index) {
                    return _react2.default.createElement(_components.WorkStationShopInfo, { pathName: '/shop/', key: item.id, index: index, shop: item });
                  }) : _react2.default.createElement(
                    'li',
                    { style: { width: '100%', fontSize: 16, textAlign: 'center' } },
                    '未搜索到相关信息'
                  )
                );
              }
              totalPageNumber = parseInt(mainSearchShopListRecordCount / mainSearchShopListPagesize, 10);
              if (mainSearchShopListRecordCount % mainSearchShopListPagesize > 0) {
                ++totalPageNumber;
              }
              break;
            case 'designer':
              var mainSearchDesignerList = data.mainSearchDesignerList;
              var mainSearchDesignerListError = data.mainSearchDesignerListError;
              var mainSearchDesignerListRecordCount = data.mainSearchDesignerListRecordCount;
              var mainSearchDesignerListPagesize = data.mainSearchDesignerListPagesize;

              if (mainSearchDesignerListError) {
                productDiv = _react2.default.createElement(
                  'li',
                  { style: { width: '100%', fontSize: 16, textAlign: 'center' } },
                  mainSearchDesignerListError
                );
              } else {
                if (location.query && !isNaN(parseInt(location.query.page, 10))) {
                  currentPage = parseInt(location.query.page, 10);
                }
                productDiv = _react2.default.createElement(
                  'ul',
                  { style: { width: '100%' } },
                  mainSearchDesignerList instanceof Array ? mainSearchDesignerList.map(function (item, index) {
                    return _react2.default.createElement(_components.ProductInfo, { key: item.id, index: index, product: item,
                      defaultImg: 'http://tupian.goeasy.cn:9999/yipinwang/master.jpg',
                      isDesigner: !!1 });
                  }) : _react2.default.createElement(
                    'li',
                    { style: { width: '100%', fontSize: 16, textAlign: 'center' } },
                    '未搜索到相关信息'
                  )
                );
              }
              totalPageNumber = parseInt(mainSearchDesignerListRecordCount / mainSearchDesignerListPagesize, 10);
              if (mainSearchDesignerListRecordCount % mainSearchDesignerListPagesize > 0) {
                ++totalPageNumber;
              }
              break;
            default:
              break;
          }
        } else {
          var _mainSearchProductList = data.mainSearchProductList;
          var _mainSearchProductListError = data.mainSearchProductListError;
          var _mainSearchProductListRecordCount = data.mainSearchProductListRecordCount;
          var _mainSearchProductListPagesize = data.mainSearchProductListPagesize;

          if (_mainSearchProductListError) {
            productDiv = _react2.default.createElement(
              'li',
              { style: { width: '100%', fontSize: 16, textAlign: 'center' } },
              _mainSearchProductListError
            );
          } else {
            if (location.query && !isNaN(parseInt(location.query.page, 10))) {
              currentPage = parseInt(location.query.page, 10);
            }
            productDiv = _react2.default.createElement(
              'ul',
              { style: { width: '100%' } },
              _mainSearchProductList instanceof Array ? _mainSearchProductList.map(function (item, index) {
                var result = '';
                if (item.productCharacter === 'M0043080000000000000000001') {
                  result = _react2.default.createElement(_components.ProductInfo, { key: item.id, index: index, product: item });
                } else if (item.productCharacter === 'M0043080000000000000000002') {
                  result = _react2.default.createElement(_components.ProductInfo, { key: item.id, isCustom: true, index: index, product: item });
                }
                return result;
              }) : _react2.default.createElement(
                'li',
                { style: { width: '100%', fontSize: 16, textAlign: 'center' } },
                '未搜索到相关信息'
              )
            );
          }
          totalPageNumber = parseInt(_mainSearchProductListRecordCount / _mainSearchProductListPagesize, 10);
          if (_mainSearchProductListRecordCount % _mainSearchProductListPagesize > 0) {
            ++totalPageNumber;
          }
        }
      }

      // 排序组件显示内容
      var orderArray = [];
      var searchPlaceholderTexts = '请输入艺品名称\\关键字';
      if (searchType) {
        switch (searchType) {
          case 'product':
            orderArray = [{ id: '', text: '全部艺品' }, { id: 'isExperienceProduct', text: '爆款' }, { id: 'isExperienceGoods', text: '体验品' }, { id: 'isAppreciationGoods', text: '鉴赏品' }, { id: 'addTime', text: '新品' }, { id: 'price', text: '价格' }];
            searchPlaceholderTexts = '请输入艺品名称\\关键字';
            break;
          case 'shop':
            orderArray = [{ id: '', text: '全部店铺' }, { id: 'masterShop', text: '大师店铺', typeId: 'M0044350000000000000000002' }, { id: 'mortarStores', text: '普通店铺', typeId: 'M0044350000000000000000001' }, { id: 'zw', text: '' }, { id: 'zw', text: '' }, { id: 'zw', text: '' }];
            searchPlaceholderTexts = '请输入店铺名称\\关键字';
            break;
          case 'designer':
            orderArray = [{ id: '', text: '全部大师' }, { id: 'YataiMaster', text: '亚太大师', honorId: 'M0043120000000000000000001' }, { id: 'GuoMaster', text: '国大师', honorId: 'M0043120000000000000000002' }, { id: 'HangYeMaster', text: '行业大师', honorId: 'M0043120000000000000000004' }, { id: 'ShengMaster', text: '省大师', honorId: 'M0043120000000000000000003' }, { id: 'ShiMaster', text: '市大师', honorId: 'M0043129999999999999999999' }];
            searchPlaceholderTexts = '请输入作者名称\\关键字';
            break;
          default:
            orderArray = [{ id: '', text: '全部艺品' }, { id: 'isExperienceProduct', text: '爆款' }, { id: 'isExperienceGoods', text: '体验品' }, { id: 'isAppreciationGoods', text: '鉴赏品' }, { id: 'addTime', text: '新品' }, { id: 'price', text: '价格' }];
            searchPlaceholderTexts = '请输入艺品名称\\关键字';
            break;
        }
      } else {
        orderArray = [{ id: '', text: '全部艺品' }, { id: 'isExperienceProduct', text: '爆款' }, { id: 'isExperienceGoods', text: '体验品' }, { id: 'isAppreciationGoods', text: '鉴赏品' }, { id: 'addTime', text: '新品' }, { id: 'price', text: '价格' }];
      }
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_components.HomePageSearchBar, { placeholderTexts: searchPlaceholderTexts, defaultValue: location.query.findValue,
          changeSearchTypeToTrue: changeSearchTypeToTrue,
          changeValue: changeSearchType,
          onSearch: this.onSearch.bind(this) }),
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement(_components.MainSearchPageMiddleChangeComponent, { defaultSearchType: searchType || 'product',
          itemClick: this.onSearchChange.bind(this) }),
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement(_components.HomePageOrderBar, { texts: orderArray, location: location,
          onItemClick: this.onOrderItemClick.bind(this) }),
        _react2.default.createElement('div', { className: 'clear' }),
        productDiv,
        totalPageNumber && totalPageNumber > 1 ? _react2.default.createElement(_components.HomePagingBar, { selected: currentPage, totalPageNumber: totalPageNumber,
          onPageItemClick: this.onPageItemClick.bind(this) }) : '',
        _react2.default.createElement('div', { className: 'clear' })
      );
    }
  }]);
  return MainSeachPage;
}(_react.Component), _class2.propTypes = {
  location: _react.PropTypes.object,
  params: _react.PropTypes.object,
  productsError: _react.PropTypes.string,
  currentPage: _react.PropTypes.string,
  selectedFirstItemId: _react.PropTypes.string,
  selectedSecondItemId: _react.PropTypes.string,
  dispatch: _react.PropTypes.func,
  data: _react.PropTypes.object,
  load: _react.PropTypes.func,
  routerPush: _react.PropTypes.func,
  routerReplace: _react.PropTypes.func,
  changeCurrentPage: _react.PropTypes.func,
  loadFilterData: _react.PropTypes.func,
  filterData: _react.PropTypes.object,
  changeSearchType: _react.PropTypes.bool,
  changeSearchTypeToTrue: _react.PropTypes.func,
  changeSearchTypeToFalse: _react.PropTypes.func
}, _temp)) || _class) || _class);
exports.default = MainSeachPage;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/MainSearchPage/MainSeachPage.js
 ** module id = 1494
 ** module chunks = 0
 **/